import { Address, L1ChainId, Wei } from '../../../types'
import { ProviderInterface } from 'starknet'
import { store } from '../../../store'
import { updateActionState } from '../../../store/app/actions'
import {
  buildStarkBalanceOfCallData,
  sendStarkMulticall,
} from './starkMulticall'
import { EthereumBalances } from '../../../store/link/types'
import { updateEthereumBalances } from '../../../store/web3/actions'

export async function callStarknetBalanceOf({
  layerOneChainId,
  multicallAddress,
  provider,
  accountAddress,
  tokenAddresses: erc20Addresses,
}: {
  layerOneChainId: L1ChainId
  multicallAddress: Address
  provider: ProviderInterface
  accountAddress: Address
  tokenAddresses: Address[]
}) {
  try {
    if (!multicallAddress) {
      return
    }
    if (!provider) {
      return
    }

    if (!erc20Addresses.length) {
      return
    }

    let balances: Wei[] = []
    store.dispatch(
      updateActionState({
        action: 'ethereumBalancesPulling',
        state: true,
      }),
    )

    try {
      const calls = buildStarkBalanceOfCallData(accountAddress, erc20Addresses)
      const result = await sendStarkMulticall(provider, multicallAddress, calls)

      balances = result.map((v) => v.toString())
    } catch (e) {
      console.error(e)
    }

    const update: EthereumBalances = {
      [layerOneChainId]: {},
    }

    erc20Addresses.forEach((v, i) => {
      update[layerOneChainId][v] = balances[i]
    })

    store.dispatch(
      updateEthereumBalances({
        ethereumBalances: update,
      }),
    )
  } catch (e) {
    console.error(e)
  } finally {
    store.dispatch(
      updateActionState({
        action: 'ethereumBalancesPulling',
        state: false,
      }),
    )
  }
}
